<template>
  <div class="safe-padding">
    <div ref="commentRef" class="comment-wrapper">
      <cube-input
        v-model="comment"
        placeholder="说说你的想法~"
        style="background-color: #F7F7F7; border-radius: 5px; text-align: left; margin-right: 10px;"
        :style="{ width: isEditingComment ? '85%' : '70%' }"
        @focus="onCommentFocus"
        @blur="onCommentBlur"></cube-input>
      <template v-if="isEditingComment">
        <span style="color: #363636; font-size: 14px; width: 50px;" @click="sendComment">发送</span>
      </template>
      <template v-else>
        <span class="icon icon-comment" style="margin-right: 10px;" @click="showCommentPanel">{{ commentNum }}</span>
        <span class="icon icon-approve" :class="[isLike ? 'is-active' : '']" @click="updateLikeStatus">{{ likeNum }}</span>
      </template>
    </div>

    <div v-if="commentPanelVisible" class="mask">
    </div>
    <div v-if="commentPanelVisible" class="comment-panel safe-padding">
      <header>
        {{ commentNum }}条评论
        <i class="cubeic-close" style="position: absolute; right: 15px; font-size: 20px" @click="hideCommentPanel"></i>
      </header>
      <cube-scroll style="height: 320px; text-align: left;">
        <ul>
          <li v-for="(item, index) in commentList" :key="index">
            <div style="display: flex; justify-content: flex-start; ">
              <img v-if="item.avatar.resUrl" :src="item.avatar.resUrl" style="width: 30px; height: 30px; border-radius: 50%;" />
              <div v-else style="background-color: #007aff; color: #fff; border-radius: 50%; width: 30px; height: 30px; line-height: 30px;">
                {{ item.name.substr(0, 1) }}
              </div>

              <div style="margin-left: 10px;">
                <div style="color: #545454; line-height: 15px; font-size: 13px; margin-bottom: 5px;">{{item.name}}</div>
                <div style="color: #9D9D9D; line-height: 15px; font-size: 12px;">{{item.time}}</div>

                <div style="color: #545454; font-size: 13px; line-height: 18px; margin-top: 10px;">
                  {{ item.content }}
                </div>
              </div>
            </div>
          </li>
        </ul>
      </cube-scroll>
      <div class="comment-wrapper" style="position: relative;">
        <cube-input
          v-model="comment"
          placeholder="说说你的想法~"
          style="background-color: #F7F7F7; border-radius: 5px; width: 85%; text-align: left; margin-right: 10px;"
          @blur="setScrollTop">
        </cube-input>
        <span style="color: #363636; font-size: 14px; width: 50px;" @click="sendComment">发送</span>
      </div>
    </div>
  </div>
</template>

<script>
import { getIsLike, updateCourseLike, getCommentAndLikeCount, courseComment, getCommentList } from '@/api/course'

export default {
  name: 'Comment',
  props: {
    courseId: {
      type: Number,
      required: true
    }
  },
  data () {
    return {
      comment: '',
      isEditingComment: false,
      isLike: false,
      likeNum: '',
      commentNum: '',
      commentPanelVisible: false,
      commentList: []
    }
  },
  methods: {
    getCommentAndLikeCount () {
      getCommentAndLikeCount({ courseId: this.courseId }).then(res => {
        this.likeNum = res.data.likeNum
        this.commentNum = res.data.commentNum
      })
    },
    getIsLike () {
      getIsLike({ courseId: this.courseId }).then(res => {
        this.isLike = res.data.isLike
      })
    },
    updateLikeStatus () {
      updateCourseLike({
        courseId: this.courseId,
        isLike: !this.isLike
      }).then(res => {
        this.getIsLike()
        this.getCommentAndLikeCount()
      })
    },
    onCommentFocus () {
      console.log('focus')
      this.isEditingComment = true
    },
    onCommentBlur () {
      console.log('blur')
      setTimeout(() => {
        this.isEditingComment = false
        // this.$router.go(0)
        this.setScrollTop()
      }, 300)
    },
    sendComment () {
      if (this.comment) {
        courseComment({ courseId: this.courseId, content: this.comment }).then(res => {
          this.$createToast({
            txt: '评论成功',
            type: 'correct'
          }).show()

          this.getCommentAndLikeCount()
          this.getCommentList()
          this.comment = ''
        })
      }
    },
    showCommentPanel () {
      this.commentPanelVisible = true
      this.getCommentList()
    },
    hideCommentPanel () {
      this.commentPanelVisible = false
    },
    getCommentList () {
      getCommentList({ courseId: this.courseId, page: 1, size: 1000 }).then(res => {
        this.commentList = res.data.records
      })
    },
    setScrollTop () {
      let top = document.documentElement.scrollTop || window.pageYOffset || document.body.scrollTop
      window.scrollTo(0, top + 1)
      setTimeout(() => {
        window.scrollTo(0, top)
      }, 300)
    }
  }
}
</script>

<style lang="stylus" scoped>
.comment-wrapper
  box-sizing border-box
  height 50px
  border-top 1px solid #E3E3E3
  padding 6px 15px
  display flex
  justify-content flex-start
  background-color #fff
  span
    display inline-block
    line-height 37px
    flex-grow 1
  .icon
    height 100%
    padding-left 35px
    color: #545454
    font-size 13px
    line-height 40px
    text-align left
  .icon-comment
    background url("~@/assets/images/icons/icon-course-comment.png") no-repeat 10px center
    background-size 20px 20px
  .icon-approve
    background url("~@/assets/images/icons/icon-course-approve.png") no-repeat 10px center
    background-size 20px 20px
  .icon-approve.is-active
    background url("~@/assets/images/icons/icon-course-approve-highlight.png") no-repeat 10px center
    background-size 20px 20px
.mask
  width 100%
  background #2b333f
  opacity 0.5
  position absolute
  top 0
  left 0
  bottom 0
  z-index 1000
.comment-panel
  position fixed
  left 0
  bottom 0
  width 100%
  background #fff
  z-index 2000
  header
    line-height 40px
    font-size 14px
    color #545454
    margin 0 30px
    border-bottom 1px solid #DDDDDD
  li
    padding 8px 20px
</style>
